import { autoCapitalize } from '@/utils/autoCapitalize'
import { formatCPF } from '@/utils/formatCPF/formatCPF'

class PatientDependentsListMapper {
  toDomain(persistenceData) {
    return {
      dependentId: persistenceData?.idDependente,
      name: autoCapitalize(persistenceData?.nome),
      cpf: formatCPF(persistenceData?.cpf),
      birthday: persistenceData?.dataNascimento,
      kinship: autoCapitalize(persistenceData?.grauParentesco),
      email: persistenceData?.email,
    }
  }
}

export default new PatientDependentsListMapper()
